import React from 'react';
import globalHook, { Store as StoreType } from 'use-global-hook';

import { actions } from './Actions';
import { Label, LabelSetting } from '../types/label';

type GlobalState = {
  properties: null | { tag: string; annotationState: string };
  labels: Label[];
  tags: string[];
  readOnly: boolean;
  container: null | HTMLElement;
  labelOptions: LabelSetting[];
  labelEdit: null | Label;
  labelEditCopied: boolean;
  labelSelected: null | Label;
  labelHistory: Label[];
  tagEdit: boolean;
  allLabels: boolean;
  refreshOverview: string;
};
const initialState: GlobalState = {
  properties: null,
  tags: [],
  labels: [],
  readOnly: false,
  container: null,
  labelOptions: [],
  labelEdit: null,
  labelEditCopied: false,
  labelSelected: null,
  labelHistory: [],
  tagEdit: false,
  allLabels: false,
  refreshOverview: '',
};

export type Store = StoreType<GlobalState, typeof actions>;

const useGlobal = globalHook<GlobalState, { [name: string]: Function }>(React, initialState, actions);

export default useGlobal;
